import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=643979a7&scoped=true"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"
import style0 from "./Step.vue?vue&type=style&index=0&id=643979a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643979a7",
  null
  
)

export default component.exports